<template>
  <header class="header" data-t="m-game-header">
    <div class="menu">
      <button class="menu-button" @click="goBack">
        <StIcon name="chevron-left" :size="22" />
      </button>
      <FavoriteButton
        v-if="isAuthenticated"
        type="game"
        data-t="favourite-game-qju3"
        :game-id
      />
    </div>
    <NuxtI18nLink to="/mobile" class="logo" data-t="logo">
      <StLogo compact />
    </NuxtI18nLink>
    <div class="actions">
      <StButton
        v-if="!isAuthenticated"
        size="m"
        data-t="login-button"
        class="action-button"
        replace
        type="gray"
        :label="t('header.loginButton')"
        :to="{ query: { modal: 'login' } }"
      />
      <div v-else-if="isAllAccountsEmpty">
        <StButton
          :to="{ query: { modal: 'payments', tab: 'deposit' } }"
          class="action-button"
          size="m"
          type="secondary"
          :label="t('payments.topUp')"
        />
      </div>
      <ClientOnly v-else>
        <MAccountWidget />
      </ClientOnly>
    </div>
  </header>
</template>

<script setup lang="ts">
import { useCasinoDeps } from '@st/casino/useDeps'

const { goBack } = useRouterBack()
const { isAuthenticated, MAccountWidget, isAllAccountsEmpty } = useCasinoDeps()
const { t } = useI18n()

const { gameId } = defineProps<{
  gameId: number
}>()
</script>

<style scoped>
.header {
  position: sticky;
  z-index: 100;
  top: 0;
  right: 0;
  left: 0;

  display: flex;
  align-items: center;

  height: 48px;
  padding: var(--spacing-100);

  background-color: var(--background-base);
}

.menu-button {
  all: unset;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: var(--spacing-100);
}

.actions,
.menu {
  flex: 1 1 0;
  min-width: 0;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.menu {
  display: flex;
  gap: var(--spacing-100);
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-button {
  margin-right: var(--spacing-050);
}
</style>
